import Section from '~/shared/Section';
import { H1, H3 } from '~/shared/Typography';
import { VStack } from 'native-base';
import { useGetMember, useI18n, useSpringBigStore } from '@springbig/shared';
import PlanCard from './components/PlanCard';
import useSubscriptionPlansHelpers from '~/pages/subscriptions/hooks/useSubscriptionPlansHelpers';
import React, { useEffect } from 'react';

const SubscriptionsScreen = () => {

    const { t } = useI18n();
    const {
        plans,
        subscribedPlans,
    } = useSubscriptionPlansHelpers();

    const { member } = useSpringBigStore();

    const { refetch: refreshMember } = useGetMember();

    useEffect(() => {
        refreshMember();
    }, []);

    if ((member && !member.subscriptions_enabled) || (!plans && !subscribedPlans)) {
        return (
            <VStack
                justifyContent={'center'}
                alignItems={'center'}
                flex={1}
            >
                <H1>
                    { t('subscriptions.no_plan_message') }
                </H1>
            </VStack>
        );
    }

    return (
        <Section flex={1}>
            { member && !!member.subscriptions_enabled && subscribedPlans && subscribedPlans.length > 0 &&
                <VStack space={4} marginBottom={8}>
                    <H3 textAlign={'center'}>{t('subscriptions.active_section')}</H3>
                    { subscribedPlans?.map((plan, index) => {

                        return (
                            <PlanCard plan={plan} key={index} status={'active'} />
                        );
                    })}
                </VStack>
            }
            { member && !!member.subscriptions_enabled && plans && plans.length > 0 &&
                <VStack space={4} paddingBottom={8}>
                    <H3 textAlign={'center'}>Explore plans</H3>
                    { plans?.map((plan, index) => {

                        return (
                            <PlanCard plan={plan} key={index} status={'inactive'} />
                        );
                    })}
                </VStack>
            }
        </Section>
    );
};

export default SubscriptionsScreen;
